import React,{useState,useEffect} from "react";
import { Modal, Button } from "react-bootstrap";
import DefaultButton from "../../../shared/components/DefaultButton";
import Modalpopup from "../../../shared/components/Modalpopup";
import { Form } from "react-bootstrap";
import ChatGroups from "./ChatGroups";
import { useDispatch, useSelector } from "react-redux";
import { loadGroupMemberDeleteDataRequest} from "../redux/Actions";
import AddMembers from "./AddMembers";
import Permissions from "../../../shared/components/Permissions";



const Members = ({ show, handleClose, selectedRow }) => {

    let dispatch = useDispatch();      
    const [showModal, setShowModal] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const isGroup = selectedRow?.data?.type === "group"; // Check if type is "group"
    const groupMembers = isGroup? (selectedRow?.data?.participants || []).filter((participant) => participant?.status === "0" ) : selectedRow?.data?.participants || [];   
    console.log("GroupMe",groupMembers);
    const [members, setMembers] = useState(groupMembers);
    let emp_no = JSON.parse(localStorage.getItem("emp_no"));
    let module_name = "Chat Groups";
    let permission = Permissions(emp_no, module_name);
    console.log("Permissiom",permission);
    
    useEffect(() => {
      setMembers(groupMembers);
    }, [selectedRow]);
        

    const filteredMembers = members.filter((participant) => {
      const search = searchTerm.toLowerCase();
      return (
        participant.name.toLowerCase().includes(search) ||
        participant.email?.toLowerCase().includes(search) || 
        String(participant.id).includes(search)
      );
    });
    

    const handleDeleteMember = (data) => {

               let chat_id = selectedRow.data.id

              console.log("Delete Member ID:",chat_id, data.name,data.email,data.id);
              if(chat_id && data.id){

              let request = {
                "chat_id": chat_id,
                "emp_name": data.name,
                "email": data.email,
                "employee_id": data.id    
              };
             dispatch(loadGroupMemberDeleteDataRequest(request));
             
             setMembers((prevMembers) =>
              prevMembers.filter((member) => member.id !== data.id)
            );
          
    }};             
          
    const getInitials = (name) => {return name.split(" ").map((n) => n[0]).join("").toUpperCase();};

    const getColorFromName = (name) => {
      const colors = ['#3498db', '#e67e22', '#1abc9c', '#9b59b6', '#e74c3c', '#f39c12'];
      let hash = 0;
      for (let i = 0; i < name.length; i++) {
          hash = name.charCodeAt(i) + ((hash << 5) - hash);
      }
      return colors[Math.abs(hash) % colors.length];
    };


    return (
        <div>
            {/* Show Group Name if it's a group */}
            {isGroup &&  (
                <div style={{ position: "sticky",
                  top: 0,
                  backgroundColor: "white",
                  zIndex: 10,
                  padding: "10px 0",
                  borderBottom: "1px solid #ddd", }}>
                  <h4 style={{ marginBottom: "10px", color: "#333", fontSize: "1rem" }}>
                  <strong style={{ paddingTop: "5px" }}>{selectedRow.data.chat_name}</strong>
                  
                  {permission.write_permission && (
                  <DefaultButton
                    buttonClass={"default-btn-color me-1 custom-btn"}
                    buttonTitle={" + Add Members"}
                    actionBlock={() => setShowModal(true)}                       
                  />
                )}
                  </h4>
                </div>
            )}                 

            {/* Search Bar for Filtering Members */}
            {isGroup && (
              <Form.Control type="text" placeholder="Search members..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} 
                className="mb-2 search-input-outline" 
                style={{
                position: "sticky",
                top: "50px", 
                zIndex: 9,
                backgroundColor: "white",
            }}
              />
            )}

            {/* Display Filtered Members */}
               <div style={{ marginBottom: "15px" }}>
                  {filteredMembers.length > 0 ? (filteredMembers.map((participant) => { 
                    let color = participant.userColor;
                    color = color.startsWith("0x") ? `#${color.slice(2)}` : color; // Convert 0x format to hex                 
                      return (
                         <div key={participant.id} style={{display: "flex",alignItems: "center",padding: "10px",borderBottom: "1px solid #eee",transition: "background-color 0.3s ease", }}
                onMouseEnter={(e) => (e.target.style.backgroundColor = "#f9f9f9")}
                onMouseLeave={(e) => (e.target.style.backgroundColor = "transparent")}
              >

            {/* Profile Icon */}
                <div style={{width: "35px",height: "35px",borderRadius: "50%",backgroundColor: getColorFromName(participant.name),color: "#fff",display: "flex",justifyContent: "center",alignItems: "center",fontWeight: "bold",marginRight: "10px",textTransform: "uppercase",}}>
                  {getInitials(participant.name)}
                </div>

                <div>
                  <span style={{ fontSize: "15px",}}>{participant.name}{","}    {participant.id}</span>
                  <br />
                  <span style={{ fontSize: "10px", color: "#666" }}>
                    {participant.email || "No email provided"}
                  </span>
                </div>

            {/* Delete Icon */}
                {isGroup && permission.delete_permission && (<i className="fa fa-trash"  style={{cursor: "pointer",color: "red",fontSize: "18px",marginLeft: "auto", }}
                  onClick={() => handleDeleteMember(participant)}/>)}
              </div>
               );
               })
                ) : (
                   <p style={{ color: "#888", fontStyle: "italic" }}>No matching members</p>
                )}
              </div>
            
             {/*Add Member pop up*/}   
             <Modalpopup height="80vh" size="lg" show={showModal} handleClose={() => setShowModal(false)}>
                  <div style={{ maxHeight: 'calc(100vh - 210px)', overflowY: 'auto' }}>
                    <AddMembers
                      groupMembers={groupMembers}
                      selectedRow={selectedRow}
                      onClose={() => setShowModal(false)}
                      onMembersAdded={(newMembers) => {
                        setMembers((prev) => [...prev, ...newMembers]);
                      }}
                    />
                  </div>
              </Modalpopup>

        </div>
    );
};

export default Members;
